import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'

import CellPhoneIcon from 'components/CellPhoneIcon'
import RoundedTeleportLogoIcon from 'components/RoundedTeleportLogoIcon'
import Title from '../components/Title'

import Description from '../components/Description'
import Header from '../components/Header'
import Action from '../components/Action'
import { CONTAINER, INPUT } from '../styles'
import config from 'config'

const {
  legal: { terms_conditions, privacy_policy },
} = config

const Link = ({ children, ...rest }) => (
  <a target="_blank" rel="noreferrer" className="text-current" {...rest}>
    {children}
  </a>
)

const VerificationModalChooseAuth = ({ autoFocus, onSubmit, onClose }) => {
  const buttonRef = useRef()
  useEffect(() => {
    if (autoFocus) {
      buttonRef.current.focus()
    }
  }, [autoFocus])
  return (
    <div className={CONTAINER}>
      <Header onClose={onClose} className="justify-center">
        <RoundedTeleportLogoIcon className="w-20 h-20" />
      </Header>
      <Title>Get Started</Title>
      <button ref={buttonRef} className={`mt-7 ${INPUT}`} type="button" onClick={onSubmit}>
        <CellPhoneIcon className="w-2" />
        Continue with Phone Number
        <span />
      </button>
      <Action className="mt-20">Trouble Logging In?</Action>
      <Description className="mt-4">
        By clicking Continue, you agree to our <Link href={terms_conditions}>Terms</Link>
        . Learn how we <br /> process your data in our{' '}
        <Link href={privacy_policy}>Privacy Policy</Link>
      </Description>
    </div>
  )
}

VerificationModalChooseAuth.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  autoFocus: PropTypes.bool,
}

export default VerificationModalChooseAuth
